import './App.css';
import React, { useEffect } from 'react';
import { Banner, Flex, Progress, Text } from '@pega/cosmos-react-core';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Facebook from './components/SocialMedia/Facebook/Facebook';
import Twitter from './components/SocialMedia/Twitter/Twitter';
import ABC from './components/SocialMedia/ABC/ABC';
import SMS from './components/SocialMedia/SMS/SMS';
import Header from './components/Utilities/Header';
import TwilioWhatsapp from './components/SocialMedia/TwilioWhatsapp/TwilioWhatsapp';
import AddConnection from './components/AddConnection';
import CreateTwilioWhatsapp from './components/SocialMedia/TwilioWhatsapp/CreateTwilioWhatsapp';
import CreateSMS from './components/SocialMedia/SMS/CreateSMS';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { appState } from './interfaces/common';
import { fetchSession } from './redux/actions';
import { config } from 'dotenv';
import CreateChat from './components/SocialMedia/Chat/CreateChat';
import FacebookAuthResult from './components/SocialMedia/Facebook/FacebookAuthResult';
import TwitterAuthResult from './components/SocialMedia/Twitter/TwitterAuthResult';
import CreateAPI from './components/SocialMedia/ThirdPartyConnection/CreateCustomConnection';
import ApiConnection from './components/SocialMedia/ThirdPartyConnection/CustomConnection';
import Vonage from './components/SocialMedia/Vonage/Vonage';
import CreateCustomerAISimulator from './components/SocialMedia/CustomerAISimulator/CreateCustomerAISimulator';
import Monitor from './components/monitor/Monitor';
import LandingPage from './components/LandingPage';
import CreateLanguageService from './components/configure/LanguageService/CreateLanguageService';
import LanguageService from './components/configure/LanguageService/LanguageService';
import AddConfigure from './components/configure/AddConfigure';

config();

function App() {
  const { isVerified, isValid, bannerInfo } = useSelector((state: appState) => {
    return {
      isVerified: state.isVerified,
      isValid: state.isValid,
      bannerInfo: state.bannerInfo,
    };
  });
  const { enableAgentTrainer } = useSelector((state: appState) => state);
  const dispatch = useDispatch();
  const getBannerMessage = <Text style={{ fontWeight: 'bold' }}>{bannerInfo.message}</Text>;
  useEffect(() => {
    const params = queryString.parseUrl(window.location.toString());
    dispatch(fetchSession(params.query.session_id?.toString()));
  }, [dispatch]);

  const renderContent = () => {
    if (!isVerified) {
      return <Progress placement="global" />;
    }
    return (
      <Flex className="container">
        <Router>
          <Header hideLogout={isValid} />
          {isValid ? (
            <Routes>
              <Route path={'/'} element={<LandingPage />}>
                <Route path={'/monitor'} element={<Monitor />} />
              </Route>
              <Route path={'/add-connection'} element={<AddConnection />} />
              <Route path={'/facebook/auth-result'} element={<FacebookAuthResult />} />
              <Route path={'/facebook/:id'} element={<Facebook />} />
              <Route path={'/twitter/auth-result'} element={<TwitterAuthResult />} />
              <Route path={'/twitter/:id'} element={<Twitter />} />
              <Route path={'/twilio/:id'} element={<SMS />} />
              <Route path={'/twilio-create'} element={<CreateSMS />} />
              <Route path={'/abc/:id'} element={<ABC />} />
              <Route path={'/chat/:id'} element={<CreateChat />} />
              <Route path={'/chat'} element={<CreateChat />} />
              <Route path={'/mobile/:platform'} element={<CreateChat />} />
              <Route path={'/unified-channel/:platform'} element={<CreateChat />} />
              <Route path={'/unified-channel/:platform/:id'} element={<CreateChat />} />
              <Route path={'/mobile/:platform/:id'} element={<CreateChat />} />
              <Route path={'/twilio-whatsapp/:id'} element={<TwilioWhatsapp />} />
              <Route path={'/twilio-whatsapp-create'} element={<CreateTwilioWhatsapp />} />
              <Route path={'/third-party-connection-create'} element={<CreateAPI />} />
              <Route path={'/custom/:id'} element={<ApiConnection />} />
              {enableAgentTrainer && (
                <Route path={'/customer-ai-simulator-create'} element={<CreateCustomerAISimulator />} />
              )}
              {process.env.REACT_APP_ENABLE_VONAGE === '1' && (
                <Route path={'/vonage-whatsapp/:id'} element={<Vonage />} />
              )}
              {process.env.REACT_APP_ENABLE_VONAGE === '1' && <Route path={'/vonage-sms/:id'} element={<Vonage />} />}
              <Route path={'/language-service-create'} element={<CreateLanguageService />} />
              <Route path={'/language-service/:id'} element={<LanguageService />} />
              <Route path={'/add-configuration'} element={<AddConfigure />} />

              <Navigate replace to="/"></Navigate>
            </Routes>
          ) : (
            bannerInfo.message &&
            !bannerInfo.forMonitorTab && (
              <Banner
                id="banner"
                action={getBannerMessage}
                variant={bannerInfo.variant}
                messages={['']}
                style={{ paddingTop: '1rem' }}
              />
            )
          )}
        </Router>
      </Flex>
    );
  };
  return <React.Fragment>{renderContent()}</React.Fragment>;
}

export default App;
